/**
 * "Sair da mesa" pelo menu da mesa (docs/spec/room-menus.md), no computador e no celular: pergunta
 * antes. O × da aba "Mesa", que saía num clique só, não existe mais.
 */
import { useCallback } from 'react';
import { useT } from '../i18n/index.js';
import { useApp } from '../store.js';
import { askConfirm } from '../ui/prompt.js';

export function useConfirmLeave(): () => Promise<void> {
  const t = useT();
  return useCallback(async () => {
    const name = useApp.getState().room?.name ?? '';
    const ok = await askConfirm({ title: t('room.leave.confirm.title'), message: t('room.leave.confirm.message', { name }), action: t('room.leave'), danger: true });
    if (ok) useApp.getState().leaveRoom();
  }, [t]);
}
